var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 213.27 211.79",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#2969B3;}\r\n\t.st2{fill:#222653;}\r\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:8;}\r\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:8.1379,8.1379;}\r\n\t.st6{fill:#CDEAE8;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_33"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_32"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_31"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_30"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_29"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_28"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_27"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_34"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_36"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_35"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,172.48c0,33.52,38.52,39.31,38.52,39.31s93.29,0,135.12,0s39.61-39.82,39.61-39.82s0-94.47,0-131.16 S173.81,0,173.81,0H38.52C5.04,0,0,39.9,0,39.9V172.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M52.28,27.52c0,0,48.61-27.97,110.06,0c9.63,4.13,0,16.51,0,16.51l-14.68,25.68c0,0-2.75,4.59-9.17,2.75 c-6.42-1.83-32.56-15.64-61.45,0.43c-9.08,3.19-10.25-0.59-11.92-4.1c-3.27-6.85-16.97-29.81-16.97-29.81S42.19,32.1,52.28,27.52z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.36,121.1c0,0,3.06-31.8-24.76-33.02s-26.83,22.28-26.33,28.01c0.5,5.73,10.43,40.17,10.43,40.17 l10.7,30.57c0,0,7.95,11.01,20.48,7.34s13.15-15.59,11.62-21.1c-1.53-5.5-5.2-19.87-5.2-29.04 C75.3,134.86,78.36,126.3,78.36,121.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M166.62,88.05c4.06,0.88,24.24,8.6,20.57,27.25s-19.26,65.73-19.26,65.73s-3.36,10.36-12.84,13.9 s-16.82-2.89-18.65-5.64c-1.83-2.75-7.03-11.31-2.75-20.48c4.28-9.17,5.81-28.74,3.67-40.36s-4.89-25.68,5.2-33.63 S162.56,87.17,166.62,88.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.16,65.28V33.36c0,0-0.04-3.97,3.48-3.97s3.82,3.06,3.82,5.5c0,2.45,0,30.45,0,30.45 S106.54,65.01,103.16,65.28z"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Base"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage1);
export default __webpack_public_path__ + "static/media/image1.6889362382c7f85547af51c0e305d87f.svg";
export { ForwardRef as ReactComponent };